import {Injectable} from '@angular/core';
import {FormattedNumber} from '@components/ui/table-template/classes/formatted-number';
import {EntityInvestmentListDto} from '@dto/holdings/entity-investment-list.dto';
import {EntityInvestmentDto} from '@dto/holdings/entity-investment.dto';
import {EntityInvestmentViewModel} from '../view-models/entity-investment.view-model';

@Injectable({
  providedIn: 'root'
})
export class EntityInvestmentConverterService {

  public convert(entityCode: string, entityInvestmentList: EntityInvestmentListDto): EntityInvestmentViewModel[] {
    return entityInvestmentList.entityInvestments.map(entityInvestment => this.convertSingle(entityCode, entityInvestment));
  }

  private convertSingle(entityCode: string, entityInvestment: EntityInvestmentDto): EntityInvestmentViewModel {
    return {
      entityCode: entityCode,
      id: entityInvestment.id,
      name: entityInvestment.name,
      type: entityInvestment.type,
      currency: entityInvestment.currency,
      bookValue: new FormattedNumber(entityInvestment.bookValue),
      marketValue: new FormattedNumber(entityInvestment.marketValue),
      marketValueDate: entityInvestment.marketValueDate ? new Date(entityInvestment.marketValueDate) : null,
      portfolioNumber: entityInvestment.portfolioNumber
    };
  }
}
